import React from 'react';

const Header = ({ onNavigate }) => {
  const handleClick = (e, section) => {
    e.preventDefault();
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header>
      <div className="container">
        <h1 className="logo">2CBNTV</h1>
        <nav>
          <ul>
            <li>
              <a href="#home" onClick={(e) => handleClick(e, 'home')}>
                Home
              </a>
            </li>
            <li>
              <a href="#video" onClick={(e) => handleClick(e, 'video')}>
                Video
              </a>
            </li>
            <li>
              <a href="#contact" onClick={(e) => handleClick(e, 'contact')}>
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
